import { render } from "./InputProductType.vue?vue&type=template&id=4f89d152"
import script from "./InputProductType.vue?vue&type=script&lang=js"
export * from "./InputProductType.vue?vue&type=script&lang=js"
script.render = render

export default script